<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容："  label-for="key">
              <Input search enter-button placeholder="请输入出库单号/物品名称搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选仓库："  label-for="key">
              <Select v-model="filter.warehouse_id" placeholder="请选择仓库" @on-change="select">
                <Option value="0">全部</Option>
                <Option v-for="(name, id) in warehouseList" :value="id" :key="id">{{ name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="出库类型："  label-for="key">
              <Select v-model="filter.type" placeholder="请选择出库类型" @on-change="select">
                <Option value="0">全部</Option>
                <Option value="1">基地出库</Option>
                <Option value="2">三方出库</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="审核状态："  label-for="key">
              <Select v-model="filter.audit_status" placeholder="请选择审核状态" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">未审核</Option>
                <Option :value="2">已审核</Option>
                <Option :value="3">已拒绝</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="出库状态："  label-for="key">
              <Select v-model="filter.out_status" placeholder="请选择出库状态" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">未出库</Option>
                <Option :value="2">已出库</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">
          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加出库</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="audit(row)" :disabled="row.audit_status !== 1">审核出库</a>
          <Divider type="vertical" />
          <a @click="info(row.warehouse_inventory_out_id)">查看</a>
        </template>
      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>

    <!--  审核弹窗 选择审核状态 如果是拒绝要有拒绝原因-->
    <Modal v-model="auditShow" title="审核出库">
      <Form ref="auditForm" :model="auditForm" :label-width="100" label-position="right" @submit.native.prevent style="padding:20px">
        <FormItem label="审核状态：" prop="audit_status" label-for="audit_status">
          <RadioGroup v-model="auditForm.audit_status" type="button" style="margin-bottom: 20px">
            <Radio :label="2">审核通过</Radio>
            <Radio :label="3">审核拒绝</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="拒审原因：" prop="audit_reason" label-for="audit_reason" v-if="auditForm.audit_status === 3">
          <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入拒审原因" style="width: 300px"
                 v-model="auditForm.audit_reason"></Input>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button @click="auditCancel">取消</Button>
        <Button type="primary" @click="auditOk">提交</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import {
  warehouseInventoryOutListApi,
  warehouseInventoryOutAuditApi
} from '@/api/warehouse/warehouseInventoryOut'
import {warehouseAllApi} from "@/api/warehouse/warehouse";

export default {
  name: 'warehouseInventoryOutList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        search: '',
        warehouse_id: '0',
        type: '0',
        audit_status: 0,
        out_status: 0,
        ctime: [],
      },
      auditShow: false,
      auditForm: {
        warehouse_inventory_out_id: 0,
        audit_status: 2,
        audit_reason: '',
        location: '',
      },
      warehouseList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '出库单号',
          key: 'warehouse_inventory_out_sn',
          minWidth: 200
        },
        {
          title: '出库类型',
          key: 'type_msg',
          minWidth: 120
        },
        {
          title: '仓库名称',
          key: 'warehouse_name',
          minWidth: 120
        },
        {
          title: '创建人',
          key: 'admin_user_name',
          minWidth: 120
        },
        {
          title: '物品名称',
          key: 'goods_name',
          minWidth: 160
        },
        {
          title: '出库数量',
          key: 'out_num',
          minWidth: 100
        },
        {
          title: '单位',
          key: 'unit',
          minWidth: 100
        },
        {
          title: '出库状态',
          key: 'out_status_msg',
          minWidth: 120
        },
        {
          title: '审核状态',
          key: 'audit_status_msg',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }
      ]
    }
  },
  created () {
    this.loadWarehouseList()
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      warehouseInventoryOutListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 清空搜索
    searchClear () {
      this.filter.search = ''
      this.filter.page = 1
      this.loadTableData()
    },
    // 下拉选择
    select (status) {
      this.filter.page = 1
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },
    // 审核 展示
    audit(row){
      this.auditForm.warehouse_inventory_out_id = row.warehouse_inventory_out_id
      this.auditForm.audit_status = 2
      this.auditForm.audit_reason = ''
      this.auditShow = true
    },
    // 审核 确认
    auditOk() {
      warehouseInventoryOutAuditApi(this.auditForm).then(res => {
        if (res.code === 200) {
          this.$Message.success('成功')
          this.auditShow = false
          this.reload()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 审核 取消
    auditCancel() {
      this.auditForm.warehouse_inventory_out_id = 0
      this.auditForm.audit_status = 2
      this.auditForm.audit_reason = ''
      this.auditShow = false
    },

    // 加载仓库
    loadWarehouseList() {
      warehouseAllApi().then(res => {
        //数据赋值
        this.warehouseList = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
